import { render, staticRenderFns } from "./PhotoProfileGroupChatGray.vue?vue&type=template&id=f9689088"
import script from "./PhotoProfileGroupChatGray.vue?vue&type=script&lang=js"
export * from "./PhotoProfileGroupChatGray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports